// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__2jdKG","grid_item":"style_grid_item__16Tot","item__icon":"style_item__icon__fzX5m","item__title":"style_item__title__1NCjl"};